import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/axios';

export const uploadResume = createAsyncThunk('resume/uploadResume', async (file, thunkAPI) => {
    try {
        const formData = new FormData();
        formData.append("resume", file);

        const res = await api.post("/api/resume/parseresume", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });

        thunkAPI.dispatch(setResumeData(res.data.data));
        return res.data.data;
    } catch (err) {
        return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
}
);

const resumeSlice = createSlice({
    name: 'resume',
    initialState: {
        resumeData: null,
        loading: false,
        error: null
    },
    reducers: {
        clearResume: (state) => {
            state.resumeData = null;
            state.error = null;
        },
        setResumeData: (state, action) => {
            state.resumeData = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(uploadResume.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(uploadResume.fulfilled, (state, action) => {
                state.loading = false;
                state.resumeData = action.payload;
            })
            .addCase(uploadResume.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { clearResume, setResumeData } = resumeSlice.actions;
export default resumeSlice.reducer;
